import React from 'react';
import PropTypes from 'prop-types';
import { Info } from 'lucide-react';
import './EmptyState.css';

/**
 * EmptyState Component
 * 
 * A reusable component for displaying empty/null data states in a trust-building way.
 * Uses declarative, context-specific messages instead of generic "No data" or "N/A".
 * 
 * @param {string} message - The declarative message to display
 * @param {boolean} showIcon - Whether to show the info icon (default: true)
 * @param {string} className - Additional CSS classes to apply
 * @param {string} iconSize - Size of the icon in pixels (default: 16)
 */
const EmptyState = ({ 
  message, 
  showIcon = true, 
  className = '', 
  iconSize = 16 
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {showIcon && (
        <Info 
          size={iconSize} 
          className="empty-state-icon"
          aria-hidden="true"
        />
      )}
      <span className="empty-state-message">{message}</span>
    </div>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  iconSize: PropTypes.number,
};

export default EmptyState;
